import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header.tsx";
import { Footer } from "@/components/Footer.tsx";
import { TopPage } from "@/pages/TopPage.tsx";
import { BwhRangePage } from "@/pages/BwhRangePage.tsx";
import { CupSizePage } from "@/pages/CupSizePage.tsx";
import { ProfilePage } from "@/pages/ProfilePage.tsx";
import { FeedPage } from "@/pages/FeedPage.tsx";
import { SalePage } from "@/pages/SalePage.tsx";
import "./index.css";

export function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen bg-background">
        <Header />
        <main className="flex-1 flex flex-col">
          <Routes>
            <Route path="/" element={<TopPage />} />
            <Route path="/actress/:id" element={<ProfilePage />} />
            <Route path="/cup/:size" element={<CupSizePage />} />
            <Route path="/bust/:range" element={<BwhRangePage />} />
            <Route path="/waist/:range" element={<BwhRangePage />} />
            <Route path="/hip/:range" element={<BwhRangePage />} />
            <Route path="/feed" element={<FeedPage />} />
            <Route path="/sale" element={<SalePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
